import React from 'react';

const AuthenticationMessage = () => {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#f5f5f5',
      padding: '2rem'
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '3rem',
        borderRadius: '16px',
        boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
        maxWidth: '600px',
        textAlign: 'center'
      }}>
        <div style={{
          fontSize: '4rem',
          marginBottom: '2rem'
        }}>🔐</div>
        
        <h1 style={{
          color: '#1a1a1a',
          marginBottom: '1rem',
          fontSize: '2rem'
        }}>
          Authentication System Updated
        </h1>
        
        <p style={{
          color: '#666',
          fontSize: '1.1rem',
          lineHeight: '1.6',
          marginBottom: '2rem'
        }}>
          We've implemented a more reliable Django-based authentication system 
          to eliminate the 403/504 errors you were experiencing.
        </p>
        
        <div style={{
          backgroundColor: '#e3f2fd',
          border: '1px solid #2196f3',
          color: '#1976d2',
          padding: '1.5rem',
          borderRadius: '8px',
          marginBottom: '2rem',
          textAlign: 'left'
        }}>
          <h3 style={{ margin: '0 0 1rem 0' }}>✅ What's Fixed:</h3>
          <ul style={{ margin: 0, paddingLeft: '1.5rem' }}>
            <li>No more 403 Forbidden errors</li>
            <li>No more 504 Gateway timeout errors</li>
            <li>Reliable server-side authentication</li>
            <li>Proper CSRF protection</li>
            <li>Session-based security</li>
          </ul>
        </div>
        
        <div style={{
          backgroundColor: '#fff3cd',
          border: '1px solid #ffeaa7',
          color: '#856404',
          padding: '1.5rem',
          borderRadius: '8px',
          marginBottom: '2rem',
          textAlign: 'left'
        }}>
          <h3 style={{ margin: '0 0 1rem 0' }}>🎯 How to Login:</h3>
          <ol style={{ margin: 0, paddingLeft: '1.5rem' }}>
            <li>Use the Django login page (recommended)</li>
            <li>Enter your credentials</li>
            <li>Get redirected back to the React app</li>
            <li>Enjoy reliable authentication!</li>
          </ol>
        </div>
        
        <div style={{
          display: 'flex',
          gap: '1rem',
          justifyContent: 'center',
          flexWrap: 'wrap'
        }}>
          <a 
            href="http://localhost:8000/auth/login/"
            style={{
              padding: '1rem 2rem',
              backgroundColor: '#FFD700',
              color: '#1a1a1a',
              textDecoration: 'none',
              borderRadius: '8px',
              fontWeight: '600',
              fontSize: '1.1rem',
              transition: 'background-color 0.2s'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#e6c200'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#FFD700'}
          >
            🎯 Django Login (Recommended)
          </a>
          
          <a 
            href="/login"
            style={{
              padding: '1rem 2rem',
              backgroundColor: '#6c757d',
              color: 'white',
              textDecoration: 'none',
              borderRadius: '8px',
              fontWeight: '600',
              fontSize: '1.1rem',
              transition: 'background-color 0.2s'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#5a6268'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#6c757d'}
          >
            ⚛️ Try React Login
          </a>
        </div>
        
        <div style={{
          marginTop: '2rem',
          padding: '1rem',
          backgroundColor: '#f8f9fa',
          borderRadius: '6px',
          fontSize: '0.9rem',
          color: '#666'
        }}>
          <strong>Admin Credentials:</strong> admin@gcra.gov.za / admin123
        </div>
      </div>
    </div>
  );
};

export default AuthenticationMessage;
